import {useState, useEffect, useRef} from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useNavigate } from '@plasma/ui.application.router';
import notification from '@plasma/ui.feedback.notification';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import { fetchAllDataGet_byApiName, fetchAllDataGetFromAppFile_byApiName } from '../../services/gets/getdata';
import { sendAllFileByPost, getFileByGuid_Post, pollForFile } from '../../services/posts/postdata';
import translations from './i18n';
import { RoleBaseDesignProps } from './role-base-design';
import help from './role-base-design.help';
import { apiUriDesignDrawingsHttp, apiUriMasterDataHttp } from '../../services/conf/apiConf';

function useRoleBaseDesignHook(props: RoleBaseDesignProps) {
  useResourceBundle(translations, undefined, '7f03cacb-3bb9-4b1c-ab34-b6c3e328a508');
  useHelpBundle(help);

  const { t } = useTranslation();

  const isFirstRender = useRef(true);
  const [rollPass, setrollPass] = useState<any>();
  const [rollPassInModal, setrollPassInModal] = useState<any>();
  const [selectedFile, setSelectedFile] = useState<File>();
  const [buttons, setButtons] = useState<any[]>([]);
  const [distinctProdType, setdistinctProdType] = useState<any[]>([]);
  const [dataFromApi, setdataFromApi] = useState([]);
  const [dataForGuid, setdataForGuid] = useState([]);
  const [pdfToShow, setpdfToShow] = useState('');
  const [showPhoto, setshowPhoto] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [showButtonBox, setshowButtonBox] = useState(true);
  const [guidByProd, setguidByProd] = useState("");
  const [guidByProdArray, setguidByProdArray] = useState([]);
  const [iFrameSrc, setIframeSrc] = useState("");
  const [contentType, setContentType] = useState("");
  const [buttonTitle, setButtonTitle] = useState("");
  const [count, setcount] = useState(0);
  const [pageNumber, setpageNumber] = useState(0);
  const [roleID, setroleID] = useState<number | null>(null);
  const [loadingFile, setLoadingFile] = useState(false);

  const navigate = useNavigate();

  // useEffect(() => {
  //   fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()).then((data) => {
  //     setdataFromApi(data);
  //   }).catch((error)=>{
  //     console.log("Failed to Fetch Data");
  //   });

  //   fetchAllDataGetFromAppFile_byApiName("GetDocumentGuids").then((data) => {
  //     setdataForGuid(data);
  //   }).catch((error)=>{
  //     console.log("Failed to Fetch Data");
  //   });
  // },[]);

  useEffect(() => {
    setLoadingFile(true);

    Promise.all([
      fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()),
      fetchAllDataGetFromAppFile_byApiName("GetDocumentGuids", apiUriDesignDrawingsHttp())
    ])
    .then(([masterData, guidData]) => {
      setdataFromApi(masterData);
      setdataForGuid(guidData);
    })
    .catch((error) => {
      console.error("Failed to Fetch Data from one or more APIs", error);
    })
    .finally(() => {
      setLoadingFile(false);
    });
  }, []);

  useEffect(() => {
    if (!roleID) {
      const storedData = sessionStorage.getItem('roleid');
      if (storedData) { setroleID(JSON.parse(storedData)) }
    }
  }, [roleID]);

  useEffect(() => {
    const distinctProductTypes = Array?.from(new Set(dataFromApi?.map(item => item.producttype)));
    setdistinctProdType(distinctProductTypes);
  },[dataFromApi]);

  useEffect(() => {
    const buttonField = distinctProdType?.map((item) => {
      const oneNewItem = {title: item}
      return oneNewItem;
    });
    setButtons(buttonField);
  },[distinctProdType]);

  // useEffect(() => {
  //   if(buttonTitle !== "" && dataForGuid && dataForGuid?.length>0){
  //     const guidByProdType = dataForGuid?.find(item => item.producttype === buttonTitle);
  //     setguidByProdArray(guidByProdType?.guid);
  //     setguidByProd(guidByProdType?.guid[0]);
  //     setcount(0);
  //   }
  // },[buttonTitle, dataForGuid]);

  useEffect(() => {
    if (buttonTitle !== "" && dataForGuid && dataForGuid?.length > 0) {
      const guidByProdType = dataForGuid?.find(item => item.producttype === buttonTitle);

      if (guidByProdType && guidByProdType.guid && guidByProdType.guid.length > 0) {
        setguidByProdArray(guidByProdType.guid);
        setguidByProd(guidByProdType.guid[0]);
        setcount(0);
      } else {
        // Fallback option 1: The product profile exists, but zero document GUID mappings match it
        setguidByProdArray([]);
        setguidByProd("");
        setIframeSrc("");
        setshowPhoto(false);
        notification.info(`${buttonTitle} Drawing not found`, `No drawing found for this selection`);
      }
    }
  }, [buttonTitle, dataForGuid]);

  const handleNextPage = () => {
    if (guidByProdArray?.length > 1 && count < (guidByProdArray?.length-1)){
      const guidindex = count + 1;
      //console.log('page no. : ',guidindex+1);
      setpageNumber(guidindex+1);
      setcount(count+1);
      setguidByProd(guidByProdArray[guidindex]);
    }
  };

  const handlePreviousPage = () => {
    if(count > 0){
      const guidindex = count - 1;
      setpageNumber(guidindex+1);
      setcount(count-1);
      setguidByProd(guidByProdArray[guidindex]);
    }
  };

  const handleButtonClick = (title: any) => {
    setButtonTitle(title);
    setpageNumber(1);
  };

  async function fetchAndSetIframeSource() {
    if (!guidByProd) return false;
    const queryParams = new URLSearchParams({ guid: guidByProd });
    setLoadingFile(true);
    // console.log(queryParams)
    try {
      const blob = await pollForFile(`getRollPassDesign?${queryParams}`, {}, undefined, undefined, apiUriDesignDrawingsHttp());
      // const blobUrl = URL.createObjectURL(blob);
      // setIframeSrc(blobUrl);
      if (blob && blob.size > 0) {
        const blobUrl = URL.createObjectURL(blob);
        setIframeSrc(blobUrl);
        return true;
      }else {
        setIframeSrc('');
        setshowPhoto(false);
        return false;
       }
    }catch (error) {
      console.log(error);
      notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3);
      return false;
    }finally {
      setLoadingFile(false);
    }
  }

  const handleAfterButtonClick = () => {
  // console.log('guid: ',guidByProd);
  //   // const queryParams = new URLSearchParams({
  //   //   guid: guidByProd
  //   //   // Add more query parameters as needed
  //   // });

  //   // getFileByGuid_Post(`getRollPassDesign?${queryParams}`,{})
  //   // .then((response) => {
  //   //   //console.log(response);
  //   //   setIframeSrc(response);
  //   // }).catch((error) => {
  //   //     console.log(error);
  //   //     notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
  //   //   });

    fetchAndSetIframeSource();
    setshowPhoto(true);
  };

  useEffect(() => {
    if (guidByProd !== '' && guidByProd !== undefined && guidByProd !== null ) {
      handleAfterButtonClick();
    }
    else{
      setIframeSrc('');
    }
  }, [guidByProd]);

  const handleGoHome = () => {
    navigate('/home-screen');
  };

  const handleRollPassChange = (value : string) => {
    //console.log('roll pass: ',value);
    setrollPass(value);
  }

  const handleShowModal = () => {
    setshowModal(true);
  }

  const handleSaveFromModal = () => {
    const formData = new FormData();
    if(selectedFile){
      formData.append('File', selectedFile);
      formData.append('ProductType', rollPassInModal);

      console.log('Data to send: ', formData);

      sendAllFileByPost('uploadRollPassDesign', formData, undefined, apiUriDesignDrawingsHttp())
        .then((response) => {
          console.log('API Response: ', response);
          if(response){
            fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()).then((data) => {
              setdataFromApi(data);
              notification.success('Success !', 'File Saved Successfully', undefined, 'medium', 3)
            }).catch((error)=>{
              console.log("Failed to EditPlantLayout");
            });

            fetchAllDataGetFromAppFile_byApiName("GetDocumentGuids", apiUriDesignDrawingsHttp()).then((data) => {
              //set the response
              setdataForGuid(data);
            }).catch((error)=>{
              console.log("Failed to Fetch Data");
            });
          }
        }).catch((error) => {
          console.log(error);
          notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
        });
    }
    HandleModalCancel();
  }

  const HandleModalCancel = () => {
    setrollPassInModal(null);
    setshowModal(false);
  }

  const handleRollPassChangeInModal = (value: string) => {
    setrollPassInModal(value);
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ['application/pdf'];
    if (file && allowedTypes?.includes(file.type)) {
      setSelectedFile(file);
    }
    else {
      event.target.value = ''; // Clear the input field
      alert('Please Select A PDF File.'); // Show an error message
    }
  }

  const handleButtonBoxOpen = () => {
    setshowButtonBox(!showButtonBox);
  }

  const handleDeletePDF = () => {
    const queryParams = new URLSearchParams({
      guid: guidByProd
    });

    getFileByGuid_Post(`deleteRollPassDesign?${queryParams}`,{}, apiUriDesignDrawingsHttp())
    .then((response) => {
      //console.log(response);
      if(response){
        fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()).then((data) => {
          setdataFromApi(data);
          notification.success('Removed !', 'File Deleted Permanently', undefined, 'medium', 3)
        }).catch((error)=>{
          console.log("Failed to EditPlantLayout");
        });

        fetchAllDataGetFromAppFile_byApiName("GetDocumentGuids", apiUriDesignDrawingsHttp()).then((data) => {
          setdataForGuid(data);
        }).catch((error)=>{
          console.log("Failed to Fetch Data");
        });

        setpageNumber(1);
        setIframeSrc('');
        setButtonTitle('');
        setshowPhoto(false);
      }

    }).catch((error) => {
        console.log(error);
        notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
      });
  };

  return {
    t,
    showPhoto,
    buttons,
    rollPass,
    showModal,
    rollPassInModal,
    distinctProdType,
    showButtonBox,
    iFrameSrc,
    guidByProd,
    guidByProdArray,
    pageNumber,
    roleID,
    buttonTitle,
    handleRollPassChange,
    handleGoHome,
    handleButtonClick,
    handleShowModal,
    handleSaveFromModal,
    HandleModalCancel,
    handleRollPassChangeInModal,
    handleFileUpload,
    handleButtonBoxOpen,
    handleNextPage,
    handlePreviousPage,
    setButtonTitle,
    handleDeletePDF,
    setpageNumber,
    loadingFile
  };
}

export default useRoleBaseDesignHook;
